export enum LoginAlert {
  PLANNED_MAINTENANCE = 'planned-maintenance',
  CURRENTLY_DOWN = 'currently-down',
  HOLIDAY = 'holiday-office-closure',
}
